var _rect, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVideoPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 32,
    viewBox: "0 0 34 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.480469,
    width: 33,
    height: 32,
    rx: 6,
    fill: "#E57200"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6238 14.2507C23.998 15.0122 23.998 16.9881 22.6238 17.7495L13.3502 22.8881C12.0172 23.6268 10.3809 22.6627 10.3809 21.1387L10.3809 10.8615C10.3809 9.33755 12.0172 8.37351 13.3502 9.11215L22.6238 14.2507Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoPlay);
export default __webpack_public_path__ + "static/media/video-play.a4ea3053007d182a1c09ad43037b8b4f.svg";
export { ForwardRef as ReactComponent };